// extracted by mini-css-extract-plugin
export var listItemPost = "ListItemPost-module--listItemPost--3tCh9";
export var featuredImageContainer = "ListItemPost-module--featuredImageContainer--Y9_F3";
export var postText = "ListItemPost-module--postText--7xFBf";
export var category = "ListItemPost-module--category--2OFeV";
export var title = "ListItemPost-module--title--V-IOU";
export var date = "ListItemPost-module--date--39ylM";